<template>
  <v-card
    style="max-height: 300px; height: 300px; overflow: scroll; overflow-x: hidden;"
  >
    <v-toolbar card dense color="transparent">
      <v-toolbar-title
        ><h4>Attendances - {{ type }}</h4></v-toolbar-title
      >
      <v-spacer></v-spacer>
      Type
      <v-flex lg3 md3 sd3>
        <v-select :items="categories" filled v-model="type"></v-select>
      </v-flex>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          class="elevation-0"
        >
          <template slot="items" slot-scope="props">
            <td>
              {{ props.item.sign_in_date ? "Sign In" : "Sign Out" }}
            </td>
            <td>
              {{ [props.item.first_name, props.item.last_name].join(" ") }}
            </td>
            <td class="text-xs-left">
              {{
                props.item.sign_in_date
                  ? props.item.sign_in_time
                  : props.item.sign_out_time
              }}
            </td>
            <td class="text-xs-right">{{ props.item.deadline }}</td>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import APIAttendance from "@/mixins/APIAttendance";
import Helpers from "@/mixins/helpers";
export default {
  mixins: [APIAttendance, Helpers],
  data() {
    return {
      categories: ["Student", "Staff", "Visitor", "Contractor"],
      type: "Student",
      items: [],
      headers: [
        {
          text: "",
          sortable: false,
          value: "avatar"
        },
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Date/Time", value: "progress" },
        { text: "Reason", value: "reason", align: "right" }
      ]
    };
  },
  watch: {
    type: {
      handler: function() {
        this.handleGet();
      }
    }
  },
  methods: {
    handleGet: async function() {
      try {
        if (this.type === "all") {
          this.items = await this.signIn(this.toDay);
        } else {
          this.items = await this.signIn(this.toDay, this.type.toLowerCase());
        }
      } catch (error) {
        this.$toast.error("Failed to fetch records!-", "Error", {
          position: "topCenter"
        });
      }
    }
  }
};
</script>
